/**
 * Formats a number as a currency value to the given number of decimal places using Banker's rounding.
 * @see https://en.wikipedia.org/wiki/Rounding#Round_half_to_even
 *
 * Returns null if value is not a number.
 *
 * @param {number} currency - The number to format.
 * @param {number} [decimalPlaces=2] - The number of decimal places for currency formatting.
 * @returns {number|null} The formatted currency number, or null if value is not a number.
 */
export const formatCurrency = (currency, decimalPlaces = 2) => {
  if (typeof currency !== 'number') {
    return null;
  }
  const multiplier = 10 ** decimalPlaces;
  const scaledNum = +(decimalPlaces ? currency * multiplier : currency).toFixed(8);

  const integerPart = Math.floor(scaledNum);
  const fractionalPart = scaledNum - integerPart;
  const epsilon = 1e-8; // For floating point precision

  const isHalf = fractionalPart > 0.5 - epsilon && fractionalPart < 0.5 + epsilon;
  const rounded = isHalf ? (integerPart % 2 === 0 ? integerPart : integerPart + 1) : Math.round(scaledNum);

  return decimalPlaces ? rounded / multiplier : rounded;
};
